module.exports = __webpack_public_path__ + "img/qualification-img1.1bb4386e.png";